import {Grid, Typography, Stack, useTheme, Box} from '@mui/material';
import {Pin, Link} from '@carbon/icons-react';

type IconKeyItem = {
  title: string;
  svg: string;
};

type IconKeyProps = {
  items: Array<IconKeyItem>;
};

const IconKey = ({items}: IconKeyProps) => {
  const theme = useTheme();

  return (
    <Grid container rowGap='5px' columnGap={'20px'}>
      <Grid item xs={12} pb='5px'>
        <Typography variant='h5'>Icon Key</Typography>
      </Grid>
      <Grid item xs={12} maxWidth='100%'>
        <Stack spacing='5px'>
          {items?.map((item) => (
            <Stack
              direction='row'
              spacing='10px'
              justifyContent='flex-start'
              alignItems='center'
              key={`${item.title}--Icon Key`}
            >
              <img width={32} height={32} src={item.svg} alt={item.title} />
              <Typography variant='h6'>{item.title}</Typography>
            </Stack>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={12} sm='auto'>
        <Stack spacing='5px'>
          <Stack direction='row' spacing='10px' justifyContent='flex-start' alignItems='center'>
            <Box sx={{height: '32px', width: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <Link height={20} width={20} color={theme.palette.grey[800]} />
            </Box>
            <Typography variant='h6'>Copy Link</Typography>
          </Stack>
          <Stack direction='row' spacing='10px' justifyContent='flex-start' alignItems='center'>
            <Box sx={{height: '32px', width: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <Pin height={20} width={20} color={theme.palette.grey[800]} />
            </Box>
            <Typography variant='h6'>Pin Document</Typography>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default IconKey;
